import { sendCommercialMetrics } from '@guardian/commercial-core';
import config_ from '../../lib/config';
// This is really a hacky workaround ⚠️
// TODO convert config.js to TypeScript
const config = config_;
let logged = false;
const isDev = Boolean(config.get('page.isDev', false));
const init = () => {
    if (!window.guardian.ophan)
        return;
    if (!config.get('switches.commercialMetrics', false))
        return;
    const userIsInSamplingGroup = Math.random() <= 0.01;
    const pageViewId = window.guardian.ophan.pageViewId;
    const browserId = config.get('ophan.browserId');
    if (isDev || userIsInSamplingGroup) {
        document.addEventListener('visibilitychange', function () {
            if (logged)
                return;
            logged = sendCommercialMetrics(pageViewId, browserId, isDev);
        });
    }
};
export { init };
